// src/api/todolistApi.ts
import { supabase } from "../supabaseClient";
import { Todo } from "../types/appTypes";

/** 📌 특정 날짜의 todo 목록 */
export async function getTodos(
  user_id: string,
  date: string
): Promise<Todo[]> {
  const { data, error } = await supabase
    .from("todolists")
    .select("*")
    .eq("user_id", user_id)
    .eq("date", date)
    .order("created_at", { ascending: true });

  if (error) throw error;
  return data || [];
}

/** ➕ todo 추가 */
export async function addTodo(
  user_id: string,
  task: string,
  date: string
) {
  const { data, error } = await supabase
    .from("todolists")
    .insert([{ user_id, task, is_done: false, date }])
    .select()
    .single();

  if (error) throw error;
  return data;
}

/** ✔ 체크 토글 */
export async function toggleTodo(
  id: number,
  is_done: boolean
) {
  const { error } = await supabase
    .from("todolists")
    .update({ is_done })
    .eq("id", id);

  if (error) throw error;
}

/** ✏️ todo 수정 */
export async function editTodo(
  id: number,
  task: string
) {
  const { error } = await supabase
    .from("todolists")
    .update({ task })
    .eq("id", id);

  if (error) throw error;
}

/** 🗑 삭제 */
export async function deleteTodo(id: number) {
  const { error } = await supabase
    .from("todolists")
    .delete()
    .eq("id", id);

  if (error) throw error;
}

/**
 * 🌱 누적 성장 점수 계산
 * - 하루 최대 4점
 * - 전체 최대 120점
 * - HomePage / ProgressBar / OnionDisplay 공용
 */
export async function getTotalScore(
  user_id: string
): Promise<number> {
  const { data, error } = await supabase
    .from("todolists")
    .select("is_done, date")
    .eq("user_id", user_id)
    .eq("is_done", true);

  if (error) throw error;
  if (!data) return 0;

  const dailyCount: Record<string, number> = {};

  data.forEach((row) => {
    dailyCount[row.date] = (dailyCount[row.date] || 0) + 1;
  });

  const total = Object.values(dailyCount)
    .map((count) => Math.min(count, 4)) // 하루 4개 제한
    .reduce((sum, v) => sum + v, 0);

  return Math.min(total, 120);
}
